import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import ChatMessaging from '../../components/ChatMessaging';
import {
  ArrowRightIcon,
  Clock,
  FullLogo,
  SettingIcon,
} from '@classity-edtech/ui-base/dist/components/Displays';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';
import { Typography } from '@mui/material';
import { Divider } from '@classity-edtech/ui-base/dist/components/Displays/Divider/Divider';
import Helmet from '../../components/Helmet';

export interface HomeProps extends MuiBoxProps {}

export const ChatMessagingPage = ({ className }: HomeProps) => {
  const timeLeft = '05:24';
  const progress = 80;

  const sessionCountDown = (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: globalColours['$global-colour-background-overlay'],
        borderRadius: '0 0 8px 8px',
        py: { xs: 0.5, md: 1 },
        px: 1.5,
        textAlign: 'center',
        width: { xs: '100%', md: 'fit-content' },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          backgroundColor: globalColours['$global-colour-sentiment-warning-default'],
        }}
      >
        <Box
          sx={{
            width: `${progress}%`,
            height: '100%',
            backgroundImage: `linear-gradient(to right, ${globalColours['$global-colour-sentiment-warning-default']}, ${globalColours['$global-colour-content-link-active']})`,
            position: 'relative',
            transition: 'width 0.5s ease',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: globalColours['$global-colour-sentiment-warning-default'],
            }}
          />
        </Box>
      </Box>

      <Typography
        variant='body3'
        sx={{
          color: globalColours['$global-colour-content-secondary'],
          mt: 1.5,
        }}
      >
        Private tuition starts in –{' '}
        <Box component='span' sx={{ fontWeight: 500 }}>
          {timeLeft}
        </Box>
      </Typography>
    </Box>
  );

  return (
    <>
      <Helmet />
      <Box
        sx={{
          background: globalColours['$global-colour-palette-gray-50'],
        }}
      >
        <Box
          sx={{
            pt: 1,
            px: 1,
            gap: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <FullLogo sx={{ width: '80px', height: 'auto' }} />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>{sessionCountDown}</Box>

            <Box
              sx={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
                ml: 1,
                color: globalColours['$global-colour-interactive-control-default'],
              }}
            >
              <ArrowRightIcon
                sx={{
                  width: { xs: '14px', md: '24px' },
                  height: { xs: '14px', md: '24px' },
                  transform: 'rotate(180deg)',
                }}
              />
              <Typography variant='body3'>Exit</Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', mx: { xs: 1.5, md: 2 } }}>
              <Typography variant='body3SemiBold' sx={{ display: { xs: 'none', md: 'inline' } }}>
                Time remaining
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <Clock sx={{ width: '14px', height: '14px' }} />
                <Typography variant='body3'>01: 09: 53</Typography>
              </Box>
            </Box>

            <SettingIcon
              sx={{ width: { xs: '16px', md: '20px' }, height: { xs: '16px', md: '20px' } }}
            />
          </Box>
        </Box>
        <Box sx={{ display: { xs: 'block', md: 'none' }, p: 1, pb: 2, width: '100%' }}>
          {sessionCountDown}
        </Box>

        <Divider sx={{ display: { xs: 'block', md: 'none' } }} />

        <Box sx={{ p: { xs: 0, md: 1 } }}>
          <Box
            sx={{
              background: globalColours['$global-colour-background-elevated'],
              border: {
                xs: 'none',
                md: `solid 1px ${globalColours['$global-colour-border-neutral']}`,
              },
              borderRadius: { xs: 'none', md: '8px' },
            }}
          >
            <ChatMessaging />
          </Box>
        </Box>
      </Box>
    </>
  );
};

ChatMessagingPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ChatMessagingPage.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(ChatMessagingPage)(
  ({ theme }) => `
`,
);
